import { currencyFormatter } from './CustomUtils.js'

export default function TotalsRow({ columnNumber, total, formatter }) {
  const theFormatter = formatter ? formatter : currencyFormatter()
  return (
    <tr key={'totals'}>
      <td colSpan={columnNumber} style={{ textAlign: 'right', fontWeight: 'bold' }}>Total</td>
      <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{theFormatter.format(total)}</td>
    </tr>
  )
}
